<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Paparan Premis">
        <w-card class="modern-card">
          <div class="card-content">
            <div class="premis-container">
              <div class="premis-left">
                <div class="qrcode-section">
                  <figure class="qrcode">
                    <vue-qrcode :value="'1/' + data.id" width="200" />
                    <img class="qrcode__image" src="/images/logog.png" alt="Logo" />
                  </figure>
                  <div class="action-buttons">
                    <w-button bg-color="success" @click="downloadQRCode()" class="action-btn">
                      <w-icon class="mr1">fal fa-download</w-icon>
                      Muat Turun QR Code
                    </w-button>

                    <w-button
                      v-if="$zutil.anyRole(['1', '2', '5']) && $page.props.auth.user.id == data.user_id"
                      bg-color="warning"
                      v-on="on"
                      :route="$route('daftar.premis.form',data.id)"
                      class="action-btn"
                    >
                      <w-icon class="mr2">fal fa-pencil</w-icon>
                      Kemaskini
                    </w-button>
                  </div>
                </div>
              </div>

              <div class="premis-right">
                <div class="info-section">
                  <div class="info-header">
                    <h3 class="info-title">Maklumat Premis</h3>
                    <div class="premis-id">
                      <span class="id-label">ID Premis:</span>
                      <span class="id-value">{{ data.no_premis }}</span>
                    </div>
                  </div>
                  
                  <div class="info-columns">
                    <div class="info-group">
                      <div class="info-item">
                        <div class="info-label">ID Premis</div>
                        <div class="info-value">{{ data.no_premis }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">ID eVetPermit</div>
                        <div class="info-value">{{ data.no_premis_vet || '-' }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Nama Premis</div>
                        <div class="info-value">{{ data.nama }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Kaedah Penternakan</div>
                        <div class="info-value">{{ data.kaedah }}</div>
                      </div>
                    </div>

                    <div class="info-group">
                      <div class="info-item">
                        <div class="info-label">Status</div>
                        <div class="info-value">{{ data.lkp_status }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">No Telefon</div>
                        <div class="info-value">{{ data.no_tel }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Alamat</div>
                        <div class="info-value">
                          {{ data.alamat }}<br>
                          {{ data.lkp_poskod }} {{ data.lkp_bandar }}<br>
                          {{ data.lkp_daerah }}, {{ data.lkp_negeri }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="tabs-section">
              <w-tabs 
                :items="tabs" 
                :no-slider="false" 
                active-class="primary" 
                v-model="activeTab"
                class="modern-tabs"
              >
                <!-- <template #item-content.0>
                  <div class="tab-content">
                    <h3>Lokasi</h3>
                    <p>Konten untuk tab Lokasi akan ditampilkan di sini.</p>
                  </div>
                </template> -->
                
                <template #item-content.1>
                  <div class="tab-content">
                    <Ternakan :data="data" v-if="data.id > 0" />
                  </div>
                </template>
                
                <template #item-content.2>
                  <div class="tab-content">
                    <JejakAudit :data="data" v-if="data.id > 0" />
                  </div>
                </template>

                <template #item-content.3>
                  <div class="tab-content">
                    <TernakanSmartgene :data="data" v-if="data.id > 0" />
                  </div>
                </template>

              </w-tabs>
            </div>
          </div>
        </w-card>
      <!-- </div> -->
      <div class="mt2 text-left">
          <button 
              style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              "
              @click="tutup">TUTUP
            </button>&nbsp;
        </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Ternakan from './Show/Ternakan.vue';
import TernakanSmartgene from './Show/TernakanSmartgene.vue';
import JejakAudit from './Show/JejakAudit.vue';
import VueQrcode from 'vue-qrcode'

export default {
  extends: ZResource,
  components: {
    Ternakan, VueQrcode, JejakAudit, TernakanSmartgene
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: this.api_service + "premis",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Daftar Premis & Ternakan', route: '/daftar' },
        { label: 'Premis', route: '/daftar/premis' },
        { label: 'Papar', route: '/daftar/premis/'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      activeTab : 0,
      tabs: []
    }
  },
  methods: {
    async downloadQRCode() {
      const url = route('api.premis.qrcode', { id: this.id });
      window.open(url, '_blank');
    },
    tutup(){
      this.$inertia.visit(window.route('daftar.premis.index'));
    },
    getData() {
  this.$zcomm
    .get(this.api_service + 'premis/show/' + this.id, {})
    .then(res => {
      this.data = res

      // default tabs
      this.tabs = [
        { title: 'Ternakan', content: '' },
        { title: 'Jejak Audit', content: '' },
      ]

      if (this.$zutil.role('2','5')) {
           this.tabs = [
           { title: 'Ternakan', content: '' },
           { title: 'Jejak Audit', content: '' },
           { title: 'Ternakan SmartGene', content: '' },
           ]
         }
    })
},
  },
  mounted() {
    this.getData();
  },
}
</script>

<style scoped>
/* Page Container */
.page-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Card Styles */
.modern-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  background: #fff;
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.card-title {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.close-btn {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background-color: #e9ecef;
  color: #495057;
}

.card-content {
  padding: 24px;
}

/* Main Layout */
.premis-container {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
  margin-bottom: 30px;
}

/* QR Code Section */
.qrcode-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.qrcode {
  position: relative;
  text-align: center;
  border-radius: 16px;
  background: #f8f9fb;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.qrcode__image {
  position: absolute;
  width: 18%;
  height: 18%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 4px solid #fff;
  border-radius: 8px;
}


/* --- Action Buttons --- */
.action-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 5px; /* Tambahkan sedikit jarak antar tombol */
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 18px; /* Padding sedikit lebih besar untuk keseimbangan */
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
}

.info-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.premis-id {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.id-label {
  font-weight: 500;
  color: #6c757d;
  font-size: 14px;
}

.id-value {
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.info-columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.info-group {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.info-item {
  margin-bottom: 14px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 4px;
  font-weight: 500;
}

.info-value {
  font-size: 15px;
  color: #2c3e50;
  font-weight: 500;
  text-transform: uppercase;
}

/* Tabs Section */
.tabs-section {
  margin-top: 10px;
}

.action-buttons {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px; 
  flex-wrap: wrap; 
}

.modern-tabs {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.tab-content {
  padding: 24px;
  background: #fff;
  min-height: 200px;
}

.tab-content h3 {
  margin-top: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.tab-content p {
  color: #666;
  line-height: 1.6;
}

/* Override default w-tabs styles */
:deep(.w-tabs__bar) {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

:deep(.w-tabs__item) {
  padding: 14px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  color: #6c757d;
}

:deep(.w-tabs__item:hover) {
  background-color: rgba(74, 105, 189, 0.1);
  color: #4a69bd;
}

:deep(.w-tabs__item--active) {
  color: #4a69bd;
  border-bottom: 3px solid #4a69bd;
}

:deep(.w-tabs__slider) {
  background-color: #4a69bd;
  height: 3px;
}

/* Responsive Design */
@media (max-width: 992px) {
  .premis-container {
    grid-template-columns: 1fr;
  }
  
  .info-columns {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .info-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  :deep(.w-tabs__item) {
    padding: 12px 15px;
    font-size: 14px;
  }
}
</style>